import { render, staticRenderFns } from "./MedicoDashboard.vue?vue&type=template&id=b5894798"
import script from "./MedicoDashboard.vue?vue&type=script&lang=js"
export * from "./MedicoDashboard.vue?vue&type=script&lang=js"
import style0 from "./MedicoDashboard.vue?vue&type=style&index=0&id=b5894798&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports